<template>
  <div class="poster-container">
    <div class="poster" id="success-poster">
      <img class="bg" :src="randomImage" alt="" />
      <div class="user-info">
        <div class="user-container">
          <img class="avatar" :src="info.image" alt="" />
        </div>
        <div class="title"
          ><span>{{ challengeType }}</span
          ><span class="num">{{ lessNum }}</span
          ><span>{{ lessUnit }}</span></div
        >
      </div>
      <div class="qrcde">
        <canvas id="qrcode-canvas" ref="qrcode"></canvas>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode'
import { goalData } from '../data.js'
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      posterList: [
        'https://cdnvue.gymcity.com.cn/uploads/ffacffedc8984bb28cd267e6050e8ef5.webp',
        'https://cdnvue.gymcity.com.cn/uploads/24cef0519c8cb41c4f83ca26050901cc.webp',
        'https://cdnvue.gymcity.com.cn/uploads/dd09ec4d47241079de968db8d1f6f7a8.webp'
      ],
      qrcodeUrl: '',
      goalData: goalData,
      randomImage:
        'https://cdnvue.gymcity.com.cn/uploads/ffacffedc8984bb28cd267e6050e8ef5.webp'
    }
  },
  watch: {
    value() {
      if (this.value) {
        this.init()
      }
    }
  },
  computed: {
    //挑战类型
    challengeType() {
      return (
        this.goalData.find((item) => {
          return item.id == this.info.e_type
        })?.text || ''
      )
    },
    lessUnit() {
      return (
        this.goalData.find((item) => {
          return item.id == this.info.e_type
        })?.unit || ''
      )
    },
    //挑战类型减少的数量
    lessNum() {
      if (!this.info?.ini_value || !this.info?.new_value) {
        return 0
      } else {
        return Math.abs(
          Number(
            (Number(this.info.new_value) - Number(this.info.ini_value)).toFixed(
              1
            )
          )
        )
      }
    }
  },
  created() {
    //this.init();
    this.setQrcode()
  },
  methods: {
    setQrcode() {
      let qrcode
      let fid = this.info.uid
      let env = this.$http.curEv()
      if (env === 'pro') {
        qrcode = `https://vue.gymcity.com.cn/?path=acceptrecommend&fid=${fid}&s_from=activityProject&scope=snsapi_userinfo`
      } else {
        qrcode = `https://test.gymcity.com.cn/?path=acceptrecommend&fid=${fid}&s_from=activityProject&scope=snsapi_userinfo`
      }
      this.qrcodeUrl = qrcode
    },
    init() {
      //随机海报图片
      let index = Math.floor(Math.random() * this.posterList.length)
      this.randomImage = this.posterList[index]
      this.$nextTick(() => {
        this.createQrcode()
      })
    },
    createQrcode() {
      this.$toast.loading('生成二维码中')
      //计算出二维码的实际宽度
      let screenWidth = window.screen.width
      let designWidth = 375
      let designQrcodeWidth = 75
      let qrcodeWidth = (screenWidth * designQrcodeWidth) / designWidth
      // 合成分享图
      let canvas = this.$refs.qrcode
      QRCode.toCanvas(
        canvas,
        this.qrcodeUrl,
        { width: qrcodeWidth, height: qrcodeWidth },
        (error) => {
          if (error) {
            console.log(error)
            this.$toast.clear()
            this.$toast('生成二维码失败')
            this.$emit('fail')
          } else {
            this.$nextTick(() => {
              this.$emit('finish')
            })
          }
        }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.poster-container {
  opacity: 0;
  position: fixed;
  width: 100%;
  left: 0;
  transform: translate(3000%, -50%);
  top: 50%;
  z-index: 999;
  width: 375px;
  height: 720px;
}

.poster {
  position: relative;
  width: 100%;
  height: 100%;

  .bg {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    object-fit: contain;
  }

  .user-info {
    position: absolute;
    left: 50%;
    top: 168px;
    width: 100%;
    box-sizing: border-box;
    padding: 0px 20px;
    left: 50%;
    transform: translate(-50%);
    font-family: PingFangSC, PingFang SC;
    font-weight: bold;
    font-size: 18px;
    color: #ffffff;
    line-height: 24px;

    .user-container {
      display: flex;
      align-items: center;
      padding-bottom: 12px;
      margin-bottom: 26px;

      .avatar {
        border-radius: 50%;
        width: 48px;
        height: 48px;
        box-sizing: border-box;
        border: 1px solid #ffffff;
        margin-right: 10px;
      }

      .num {
        font-family: DIN;
        font-weight: bold;
        font-size: 36px;
        color: #cbffb6;
        line-height: 24px;
      }
    }

    .title {
      font-family: MiSans, MiSans;
      font-weight: bold;
      font-size: 32px;
      color: #ff3b86;
      display: flex;
      align-items: center;
      justify-content: center;
      .num {
        font-family: DIN;
        font-weight: bold;
        font-size: 36px;
      }
    }
  }

  .qrcde {
    position: absolute;
    right: 20px;
    bottom: 23px;
    width: 75px;
    height: 75px;
  }
}
</style>
